import { Image } from "@clipboard-health/ui-components";

export function CbhLogo() {
  const basePath = process.env.REACT_APP_BASE_PATH ?? "/";

  return (
    <Image
      src={`${basePath}assets/logo/cbh-logo-without-wordmark.png`}
      alt="Clipboard Logo"
      sx={{
        width: "92px",
      }}
    />
  );
}
